import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './DynamicArea.css';
import Editor from '../editor/Editor';
import { addDroppedImageToPage } from '../../redux/actions/entities/pages';
import {
  GetActivePage,
  showAlertModal,
  getMaximumImagePerPage,
} from '../../redux/helpers';
import { imageChange } from '../../redux/actions/ui/imageChange';
import { DropLimitReached } from '../../helpers/dropHelper';

class DynamicArea extends Component {
  setDebounce() {
    this.setTimeout = clearTimeout(this.setTimeout);
    this.setTimeout = setTimeout(this.stopRendering, 400);
  }

  canDropImage = () => true

  dropImage = (item) => {
    const {
      lang,
      layouts,
      pages,
      isChange,
    } = this.props;

    this.setDebounce();
    const activePage = GetActivePage(pages.byId);

    const { isBabyPage } = activePage;
    const maximumPicturesReached = Object.keys(activePage.droppedImages).length === getMaximumImagePerPage(layouts);


    if (DropLimitReached(maximumPicturesReached, isChange, isBabyPage, activePage)) {
      showAlertModal(lang.title_notice, lang.no_more_pictures_on_the_page);
      return true;
    }

    this.props.dispatch(addDroppedImageToPage(activePage.id, item.id));

    if (isChange && !activePage.isCover) {
      this.props.dispatch(imageChange(false));
    }
  }


  render() {
    const editorProps = {
      height: 'auto',
      width: '100%',
    };

    const {
      isChange,
      placeholders,
      pages,
      lang,
      backgroundPlaceholders,
      datePlaceholders,
    } = this.props;

    return (
      <div className="DynamicArea">
        <Editor
          {...editorProps}
          canDropImage={this.canDropImage}
          dropImage={this.dropImage}
          isChange={isChange}
          placeholders={placeholders}
          backgroundPlaceholders={backgroundPlaceholders}
          datePlaceholders={datePlaceholders}
          pages={pages}
          lang={lang}
        />
      </div>
    );
  }
}

DynamicArea.defaultProps = {
  placeholders: {},
  dispatch: () => {},
  lang: {},
  layouts: {},
  isChange: false,
  pages: {},
  coverType: '',
  backgroundPlaceholders: {},
  datePlaceholders: {},
};

DynamicArea.propTypes = {
  placeholders: PropTypes.object,
  dispatch: PropTypes.func,
  lang: PropTypes.object,
  layouts: PropTypes.object,
  isChange: PropTypes.bool,
  pages: PropTypes.object,
  coverType: PropTypes.string,
  backgroundPlaceholders: PropTypes.object,
  datePlaceholders: PropTypes.object,
};

export default connect(state => ({
  placeholders: state.entities.placeholders,
  backgroundPlaceholders: state.entities.backgroundPlaceholders,
  datePlaceholders: state.entities.datePlaceholders,
  pages: state.entities.pages,
  isChange: state.editorUI.imageChange.isChange,
  layouts: state.entities.layouts.byId,
  backgroundType: state.editorUI.bookProperties.backgroundType,
  coverType: state.bookProperties.cover.type,
}))(DynamicArea);



// WEBPACK FOOTER //
// ./src/components/dynamic-area/DynamicArea.jsx